import classNames from 'classnames'

import Image from '../Image/Image'
import TextContent from '../TextContent/TextContent'
import HtmlContent from '../HtmlContent/HtmlContent'

import styles from './BulletContents.module.scss'
import Bullet from '../../../assets/images/bullet.svg'

const BulletContents = ({
  bulletIcon = Bullet,
  title,
  description,
  textContainerClass,
}) => {
  return (
    <div className={classNames(styles['bullet-container'], 'flex items-start')}>
      <Image src={bulletIcon} alt="Bullet" className={styles.image} />
      <TextContent
        title={title}
        containerClass={textContainerClass}
        titleClass={classNames(styles.title)}
      >
        <HtmlContent
          content={description}
          contentClass={classNames(styles.description)}
        />
      </TextContent>
    </div>
  )
}

export default BulletContents
